import type { JSX } from 'react';
import type { SurfaceOf } from './types';
import { Markdown } from '../components/Markdown';
import { useT } from '../i18n/useT';

export function TextSurfaceView({ surface }: { surface: SurfaceOf<'text'> }): JSX.Element {
  const t = useT();
  return (
    <section className="surface surface-text">
      {surface.provenance === 'ai-narrative' ? <span className="badge badge-ai">{t('aiNarrative')}</span> : null}
      <Markdown text={surface.markdown} />
    </section>
  );
}
